import { Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-modal-tutorial-army',
  templateUrl: './modal-tutorial-army.component.html',
  styleUrls: ['./modal-tutorial-army.component.scss']
})
export class ModalTutorialArmyComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalTutorialArmyComponent>
  ) { }

  ngOnInit() {
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
